import type { z } from 'zod';

/**
 * Check if a field exists in the schema
 * @param schema - Zod schema
 * @param fieldName - Name of the field to check
 * @returns True if field exists in schema
 */
export const hasSchemaField = (schema: z.ZodSchema, fieldName: string) => {
  const shape = (schema as any).shape;
  return shape?.[fieldName] !== undefined;
};

/**
 * Check if a field is required in the schema
 * @param schema - Zod schema
 * @param fieldName - Name of the field to check
 * @returns True if field is required (not optional)
 */
export const isSchemaFieldRequired = (
  schema: z.ZodSchema,
  fieldName: string
) => {
  const shape = (schema as any).shape;
  return hasSchemaField(schema, fieldName) && !shape?.[fieldName]?.isOptional();
};

/**
 * Create field checkers for a specific schema
 * @param schema - Zod schema to check against
 * @returns Object with hasField and isFieldRequired helper functions
 */
export const createSchemaFieldCheckers = (schema: z.ZodSchema) => {
  const shape = (schema as any).shape;

  return {
    hasField: (fieldName: string) => shape?.[fieldName] !== undefined,
    isFieldRequired: (fieldName: string) =>
      shape?.[fieldName] !== undefined && !shape?.[fieldName]?.isOptional(),
  };
};
